








































































































































import {
  Component,
  mixins,
  namespace,
  Vue,
  Prop,
} from 'nuxt-property-decorator'
import Vue2TouchEvents from 'vue2-touch-events'
import { mdiHeartOutline, mdiHeart, mdiGiftOutline } from '@mdi/js'
import { IProduct, IProductToFavourites } from '~/assets/interfaces/products'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { filterLinkToProductReviews } from '~/assets/filters/produts'
import MixinGeneral from '~/assets/mixins/general'
import ComponentProductBuyButton from '~/components/products/product-buy-button.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentProductMoreDetailsLink from '~/components/products/product-more-details-link.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
import ComponentRating from '~/components/rating/rating.vue'
import ComponentProductFeature from '~/components/products/product-feature.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentProductAspects from '~/components/products/product-aspects.vue'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentIcon from '~/components/icon/icon.vue'
import { filterBonus } from '~/assets/filters/bonus'
import ComponentProductAvailable from '~/components/products/product-available.vue'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentAddToCompareIconButton from '~/components/products/product-add-to-compare-icon-button.vue'
Vue.use(Vue2TouchEvents)

const favouritesStore = namespace('favourites')
const siteStore = namespace('site')

@Component({
  filters: {
    filterLinkToProductReviews,
    filterBonus,
  },
  components: {
    ComponentAddToCompareIconButton,
    ComponentIcon,
    ComponentProductAvailable,
    ComponentProductBuyButton,
    ComponentImage,
    ComponentRating,
    ComponentFormButtonIcon,
    ComponentProductAspects,
    ComponentCatalogLabels,
    ComponentProductFeature,
    ComponentProductMoreDetailsLink,
    ComponentProductDetailPricesLight,
  },
})
export default class ComponentProductItem1 extends mixins(MixinGeneral) {
  private mdiHeartOutline = mdiHeartOutline
  private mdiHeart = mdiHeart
  private mdiGiftOutline = mdiGiftOutline
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProduct

  @Prop({ type: String, default: null }) private aspectRatio: string | null

  @Prop({
    type: Boolean,
    default: false,
  })
  private favourite!: boolean

  // Первые карточки на экране: фото грузим сразу, от него зависит LCP
  @Prop({ type: Boolean, default: false }) private priority!: boolean

  @favouritesStore.Action('toFavourites') private toFavourites!: (
    product: IProductToFavourites
  ) => Promise<void>

  @favouritesStore.State('items') private favouritesItems!: IFavouriteItem[]

  @siteStore.Getter('getOptionsProductShadow')
  private getOptionsProductShadow!: boolean

  private imageNumber = 0

  private imagesAmount = this.item.images ? this.item.images.length : 0

  private hover(num: number) {
    this.isHiddenImageLazyLoad = true
    let numTemp = num
    if (numTemp > this.imagesAmount) {
      numTemp = this.imagesAmount
    }
    this.imageNumber = numTemp === 0 ? 0 : numTemp - 1
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  private get isInFavourites() {
    return !!this.favouritesItems.find((item) => {
      return item.id === this.item.id
    })
  }

  private isLoading = false

  private isLoadingFavourites = false
  private isHiddenImageLazyLoad = false

  private get styleImage() {
    let temp = {}
    const aspectRatio = this.aspectRatio || this.item.ratio
    if (aspectRatio) {
      temp = Object.assign(temp, {
        paddingTop: ((1 / eval(aspectRatio)) * 100).toString() + "%" // eslint-disable-line
      })
    }

    if (this.item.imageLazyLoad && !this.isHiddenImageLazyLoad) {
      temp = Object.assign(temp, {
        backgroundImage: `url("${this.item.imageLazyLoad}")`,
      })
    }
    return temp
  }

  private async addToFavourites() {
    const tempProd = {
      id: this.item.id,
    }

    this.isLoadingFavourites = true
    await this.toFavourites(tempProd)
    this.isLoadingFavourites = false
  }

  private swipeMobile(direction: string) {
    if (direction === 'left') {
      this.hover(this.imageNumber + 2)
    }
    if (direction === 'right') {
      this.hover(this.imageNumber)
    }
  }

  private get classWrapper() {
    return {
      [this.$style.product]: true,
      [this.$style.disable]: !this.item.inStock,
      [this.$style.trafaret]: this.item.trafaret,
      [this.$style.shadow]: this.getOptionsProductShadow,
      ...this.classDevice(this.$style),
    }
  }

  private styleSpacer!: IStyle
  private classImageWrapper = [this.$style.imageWrapper, this.styleSpacer.mb8]

  private get classVendorCode() {
    return [
      this.$style.vendorCode,
      this.classDevice(this.$style),
      this.styleSpacer.mb4,
    ]
  }

  private get classTitle() {
    return [this.$style.title, this.classDevice(this.$style)]
  }

  private get classRating() {
    return [this.$style.rating, this.classDevice(this.$style)]
  }

  private get classAspects() {
    return [this.$style.aspects, this.classDevice(this.$style)]
  }

  private classFeatures = [this.$style.features, this.styleSpacer.mb12]

  private get classBuy() {
    return [this.$style.buy, this.classDevice(this.$style)]
  }

  private get classToFavouriteButton() {
    return {
      [this.$style.toFavouriteButton]: true,
      [this.$style.active]: this.isInFavourites,
      ...this.classDevice(this.$style),
    }
  }

  get imageAlt() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.alt) {
      return this.item.imageMeta.alt
    }
    return null
  }

  get imageTitle() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.title) {
      return this.item.imageMeta.title
    }
    return null
  }
}
